import { render, staticRenderFns } from "./RatioInLineDetail.vue?vue&type=template&id=665928f9&scoped=true"
import script from "./RatioInLineDetail.vue?vue&type=script&lang=js"
export * from "./RatioInLineDetail.vue?vue&type=script&lang=js"
import style0 from "./RatioInLineDetail.vue?vue&type=style&index=0&id=665928f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665928f9",
  null
  
)

export default component.exports